import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AuthBtn } from '../../../components/Buttons';
import { AuthInput } from '../../../components/Inputs';
import Spacing from '../../../components/Spacing';
import { validateEmailAddress } from '../../../utils/common';
import './index.css';
import { confirmAlert } from 'react-confirm-alert';
import apiFactory from '../../../services/apiFactory';
import { identifyDevice, trackEvent } from '../../../utils/mixpanelUtil';

const ForgotPassForm = ({ onChangeView }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isLoading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email == '') {
      return confirmAlert({
        title: null,
        message: t('auth_login.validate_email'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: t('Ok'),
            className: 'error-ok-btn',
            onClick: () => {}
          }
        ]
      });
    }
    if (validateEmailAddress(email) === false) {
      return confirmAlert({
        title: null,
        message: t('auth_login.validate_email_format'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: t('Ok'),
            className: 'error-ok-btn',
            onClick: () => {}
          }
        ]
      });
    }
    setLoading(true);
    apiFactory.post(`forgot-password`, { email }).then(
      async () => {
        identifyDevice();
        trackEvent('PasswordReset', {
          action_category: 'Initiate Password Reset',
          action_outcome: 'success',
          interaction_element: 'button clicking',
          source: 'sf_web'
        });
        setLoading(false);
        return confirmAlert({
          title: null,
          message: t('forgot_password.email_sent'),
          closeOnEscape: true,
          closeOnClickOutside: true,
          buttons: [
            {
              label: t('Ok'),
              className: 'error-ok-btn',
              onClick: () => {}
            }
          ]
        });
      },
      async () => {
        identifyDevice();
        trackEvent('PasswordReset', {
          action_category: 'Initiate Password Reset',
          action_outcome: 'fail',
          interaction_element: 'button clicking',
          source: 'sf_web'
        });
        setLoading(false);
        return confirmAlert({
          title: t('alerts.error'),
          message: t('checkout.something_is_wrong'),
          closeOnEscape: true,
          closeOnClickOutside: true,
          buttons: [
            {
              label: t('Ok'),
              className: 'error-ok-btn',
              onClick: () => {}
            }
          ]
        });
      }
    );
  };

  return (
    <div className="auth-form">
      <h1>{t('forgot_password.header')}</h1>
      <h3>{t('forgot_password.header1')}</h3>
      <AuthInput
        placeholder={t('auth_login.email')}
        onChange={(e) => {
          setEmail(e);
        }}
      />
      <Spacing height={32} />
      <AuthBtn isLoading={isLoading} title={t('confirm')} onClick={onSubmit} />
      <Spacing height={40} />
      <div className={'center-align'}>
        <div
          className={'cancel-btn'}
          onClick={() => {
            onChangeView('login');
          }}>
          {t('cancel')}
        </div>
      </div>
    </div>
  );
};

ForgotPassForm.propTypes = {
  onChangeView: PropTypes.func
};

export default ForgotPassForm;
